import "../dialogConfirm/DialogConfirm.css";
import { useEffect, useState, type FC } from "react";
import { Dialog, Stack, Typography, Link, CircularProgress, Box } from "@mui/material";
import {
    ContainButtonShort,
    LinearTextDialog
} from "../../utils";
import { useNavigate } from "react-router-dom";

interface DialogStatusProps {
    open: any;
    title?: string;
    subTitle?: string;
    // confirm: () => void;
    description?: string;
    // address?: string;
    msgErr?: boolean;
    onClose: () => void;
    updateAndCreate?: boolean;
}

const DialogStatus: FC<DialogStatusProps> = ({
    open,
    title,
    subTitle,
    // confirm,
    description,
    // address,
    onClose,
    msgErr,
    updateAndCreate,
}) => {
    const navigate = useNavigate();
    const navigateViewData = () => {
        navigate(`/view-data`);
    }

    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => setShowButton(true), 5000);
            return () => clearTimeout(timer); // Cleanup on unmount
        }
    }, [open]);


    return (
        <Dialog
            open={open}
            keepMounted
            aria-describedby="dialog-slides"
            sx={{
                zIndex: 1301,
                "& .MuiDialog-paper": {
                    background: "var(--bg-dialog)",
                    borderRadius: "32px !important",
                    border: "1px solid var(--black)",
                    py: 5,
                    px: 3,
                    m: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "-webkit-center",
                    width: "380px !important",
                },
            }}
        >
            <Stack direction={"row"} gap={1} justifyContent={"center"}>
                <Typography fontSize={24} fontWeight={600}>
                    {title}
                </Typography>
                <LinearTextDialog>{subTitle}</LinearTextDialog>
            </Stack>
            {description && (
                (msgErr && description.startsWith("0x") === false) ?
                    <Typography
                        fontSize={msgErr ? 14 : 12}
                        fontWeight={400}
                        sx={{
                            overflowWrap: "break-word",
                            color: msgErr ? "var(--danger)" : "var(--black)",
                            textTransform: msgErr ? "capitalize" : "unset"
                        }}
                    >
                        {description}
                    </Typography> :
                    <Link
                        fontSize={msgErr ? 14 : 12}
                        fontWeight={400}
                        href={`${process.env.REACT_APP_SIX_SCAN_TX}/${description}`}
                        underline="always"
                        target="_blank"
                        rel="noopener"
                        sx={{
                            overflowWrap: "break-word",
                            color: msgErr ? "var(--danger)" : "var(--black)",
                            textTransform: msgErr ? "capitalize" : "unset"
                        }}>
                        {description}
                    </Link>
            )}

            <Stack direction={"row"} gap={1} justifyContent={"center"} mt={3}>
                <ContainButtonShort onClick={onClose}>OK</ContainButtonShort>
              

                {updateAndCreate && (
                    <ContainButtonShort disabled={!showButton} onClick={navigateViewData}>
                        <Box>View Data</Box>
                        {showButton ? (
                            null
                        ) : (
                            <CircularProgress sx={{ ml: '10px' }} size={16} />
                        )}
                    </ContainButtonShort>
                )}

            </Stack>
        </Dialog>
    );
};

export default DialogStatus;
